import { render, staticRenderFns } from "./LanguageForm.vue?vue&type=template&id=ea09e986&scoped=true"
import script from "./LanguageForm.vue?vue&type=script&lang=js"
export * from "./LanguageForm.vue?vue&type=script&lang=js"
import style0 from "./LanguageForm.vue?vue&type=style&index=0&id=ea09e986&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea09e986",
  null
  
)

export default component.exports